import React from "react";

function DSA() {
  return (
    <div style={{ padding: "30px" }}>
      <h2>DSA Notes</h2>
      <p>Here you will find all DSA notes uploaded by students.</p>
    </div>
  );
}

export default DSA;